export default class Alert {
    constructor(data) {
        this.data = data
    }

    key(name, fallBack = null) {
        if (name in this.data) {
            return this.data[name];
        }

        return fallBack;
    }
}